var o={ko:"ko",en:"en",ja:"ja",vi:"vi"},e=o.ko,t=Object.values(o);export{o as a,e as b,t as c};
